/** Custom Bots service — chat-api /bots. */
import constants from '../../constants'
import { getChatApiBase, getChatApiHeaders } from '../chatApiClient'
import axios from '../axiosInstance'
import {
  ChatApp,
  CustomBotAddPayload,
  CustomBotUpdatePayload,
  CustomBotListResponse,
  CustomBotResponse,
} from './types'

export async function list(
  app: ChatApp,
  apiHost: string,
  pageNo = 1,
): Promise<CustomBotListResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/bots?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function get(
  id: string,
  app: ChatApp,
  apiHost: string,
): Promise<CustomBotResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/bots/${id}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function add(
  post: CustomBotAddPayload,
  app: ChatApp,
  apiHost: string,
): Promise<CustomBotResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/bots`
  return axios
    .post(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function update(
  id: string,
  post: CustomBotUpdatePayload,
  app: ChatApp,
  apiHost: string,
): Promise<CustomBotResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/bots/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function del(
  id: string,
  app: ChatApp,
  apiHost: string,
): Promise<CustomBotResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/bots/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}
